import React from 'react';
import Select from '@/components/common/ReactSelect5';
import { StateSchema } from '@/types/api/v2/StateSchema';

const GRADES = ['K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] as const;

type Grade = typeof GRADES[number];

type Option = {
  label: Grade;
  value: Grade;
};

const GRADE_OPTIONS: Option[] = GRADES.map(label => ({ label, value: label }));

interface StateGradeSelectProps {
  selectedGrades: Record<number, string>;
  setSelectedGrades: React.Dispatch<React.SetStateAction<Record<number, string>>>;
  state: StateSchema<'id' | 'name' | 'abbreviation'>;
}

const StateGradeSelect = ({ selectedGrades, setSelectedGrades, state }: StateGradeSelectProps) => (
  <div className="tw-flex tw-items-center tw-mt-4 tw-max-h-9">
    <label
      className="tw-w-32 tw-text-sm tw-font-medium tw-overflow-hidden tw-text-nowrap tw-text-ellipsis"
      htmlFor={`${state.abbreviation}-grade`}
    >
      {state.name}:
    </label>
    <div className="tw-flex-1">
      <Select
        isClearable
        className="tw-max-w-24"
        id={`${state.abbreviation}-grade`}
        options={GRADE_OPTIONS}
        placeholder="Default"
        value={GRADE_OPTIONS.find(option => option.value === selectedGrades[state.id]) || null}
        onChange={(selectedOption: Option) => {
          setSelectedGrades((prev) => {
            if (selectedOption?.value) {
              return {
                ...prev,
                [state.id]: selectedOption.value,
              };
            }

            const { [state.id]: removed, ...rest } = prev;
            return rest;
          });
        }}
      />
    </div>
  </div>
);

export default StateGradeSelect;
